import apiFetch from './apiFetch';
import { message } from './antdMessage';

/** 指挥页导出队员 KML。必须带登录令牌，后端按查看队员权限点裁剪。 */
export async function downloadAuthorizedTeamKml() {
  const res = await apiFetch('/api/kml-export/team');
  if (!res || !res.ok) {
    message.error('导出失败，请确认已登录且有查看队员的权限');
    return;
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'team_export.kml';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
